import(/* webpackMode: "eager", webpackExports: ["ToastContainer","Bounce"] */ "/home/runner/work/weddify_home/weddify_home/node_modules/react-toastify/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/weddify_home/weddify_home/src/app/providers/ReduxProvider.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/weddify_home/weddify_home/src/assets/css/Global.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/weddify_home/weddify_home/src/components/cookies/AppCookies.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/weddify_home/weddify_home/src/components/footer/AppFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/weddify_home/weddify_home/src/components/header/AppHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppInitializeTagManager","AppPageViewTracking"] */ "/home/runner/work/weddify_home/weddify_home/src/components/tracking/AppGtm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/weddify_home/weddify_home/src/utils/AppReferral.ts");
